// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__PoCib","label":"SetPasswdForm_label__Ahxja"};